import { AfterViewInit, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as debounce from 'lodash/debounce';
import { QuickNavToc } from '../models/quick-nav-toc.model';
import { PinSearchbarService } from '../services/pin-searchbar.service';
import { storageAvailable } from '../../util/helpers';
/**
 * Offset amount to use when scrolling or checking the viewport status to account for the fixed header.
 */
var OFFSET = 60;
var QuickNavComponent = /** @class */ (function () {
    function QuickNavComponent(_route, _zone, _pinSearchbarService) {
        this._route = _route;
        this._zone = _zone;
        this._pinSearchbarService = _pinSearchbarService;
        this.searchbarPinned = false;
        this.topOffset = 56;
        this.onResize();
    }
    QuickNavComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._route.fragment.subscribe(function (fragment) {
            _this._fragment = fragment;
            _this.scrollToSection(fragment);
        });
        // Initialize jQuery elements
        // @ts-ignore
        this.$navWrapper = $(this.navWrapper.nativeElement);
        this.$page = this.$navWrapper.closest('.detail-page');
        this.$sections = this.$page.find('.scroll-spy-section');
        if (storageAvailable('localStorage')) {
            var storageVal = localStorage.getItem('searchbarPinned');
            this.searchbarPinned = storageVal === 'true';
        }
        if (this.screenWidth != null && this.screenWidth < 760) {
            this.topOffset = 48;
        }
        // Initialize sticky behavior and event handler
        this._zone.runOutsideAngular(function () {
            _this.$navWrapper.stick_in_parent({
                parent: _this.$page,
                offset_top: _this.searchbarPinned ? _this.topOffset : 0
            });
            setTimeout(function () { return _this.updateActiveEntry(); }, 50);
            // @ts-ignore
            $(window).on('resize scroll', debounce(_this.updateActiveEntry.bind(_this), 50));
        });
        this._pinSearchbarService.pinSearchbarClickedEvent.subscribe(function (pinned) {
            _this.searchbarPinned = pinned;
            _this.$navWrapper.trigger('sticky_kit:detach');
            _this.$navWrapper.stick_in_parent({
                parent: _this.$page,
                offset_top: _this.searchbarPinned ? _this.topOffset : 0
            });
        });
    };
    QuickNavComponent.prototype.updateActiveEntry = function () {
        var _this = this;
        var entry = this.getFirstSectionInViewport();
        if (entry !== this.activeEntry) {
            this._zone.run(function () { return _this.activeEntry = entry; });
        }
    };
    QuickNavComponent.prototype.getFirstSectionInViewport = function () {
        var _loop_1 = function (section) {
            // @ts-ignore
            var $section = $(section);
            if ($section['isInViewport'](OFFSET * 2)) {
                var id_1 = $section.attr('id');
                return { value: this_1.toc.entries.filter(function (e) { return e.fragment === id_1; })[0] };
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.$sections; _i < _a.length; _i++) {
            var section = _a[_i];
            var state_1 = _loop_1(section);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return null;
    };
    QuickNavComponent.prototype.scrollToSection = function (fragment) {
        if (!fragment) {
            return;
        }
        // @ts-ignore
        var $target = $('#' + fragment);
        if ($target.length) {
            var top_1 = $target.offset().top - OFFSET;
            // @ts-ignore
            $('html, body').animate({ scrollTop: top_1 }, 500);
        }
    };
    QuickNavComponent.prototype.onEntryClick = function (entry) {
        // If the current URL fragment matches the one that is clicked, it won't trigger a scroll, so trigger it
        // manually.
        if (this._fragment === entry.fragment) {
            this.scrollToSection(entry.fragment);
        }
    };
    QuickNavComponent.prototype.onResize = function (event) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth != null && this.screenWidth < 760) {
            this.topOffset = 48;
        }
        else {
            this.topOffset = 56;
        }
        this._pinSearchbarService.pinSearchbarClicked(this.searchbarPinned);
    };
    return QuickNavComponent;
}());
export { QuickNavComponent };
